module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qS4KWH/tc-custom/9781459216273.jpg?1718182738310",
      "alt": "This image is the cover for the book Proof of Life"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Proof of Life\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("CSI investigator Shanna Dawson has never forgiven herself for the long-ago disappearance of her little sister, Skylar. For fourteen years there have been no leads"), _c('i', [_vm._v("or")]), _vm._v(" proof of life. Until now. Until Skylar's fingerprints implicate her in a murder at a fraternity house. Shanna is desperate to find the young woman. And so is handsome campus cop Quinn Murphythe victim's half brother. But as their team investigation leads to an unexpected closeness and the revelation of family secrets, Shanna prays that her sister is innocent. "), _c('i', [_vm._v("And")]), _vm._v(" that the real killer is caught before Quinn is hurt, or Skylar is lost forever."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Scott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Laura Scott is honored to write for the Love Inspired Suspense line, where a reader can find a heartwarming journey of faith amid the thrilling danger. A registred nurse by day and an author by night, she has more ideas than time to write! She lives with her husband of thirty-five years in Wauwatosa, Wisconsin. Visit Laura at www.laurascottbooks.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0